import { render, staticRenderFns } from "./MaturityRating.vue?vue&type=template&id=59b693c1"
import script from "./MaturityRating.vue?vue&type=script&lang=js"
export * from "./MaturityRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports